var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#5078C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35722_277391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7772 11.0843H14.5425C14.9306 11.0843 15.2455 10.7735 15.2455 10.3897C15.2455 10.0062 14.9306 9.69531 14.5425 9.69531H12.7772C12.3891 9.69531 12.0742 10.0062 12.0742 10.3897C12.0742 10.7735 12.3891 11.0843 12.7772 11.0843Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.569 5.5H14.536C13.657 5.50066 12.9458 6.20294 12.9453 7.07051V8.96803H14.2614V7.07051C14.2617 6.92109 14.3847 6.7996 14.536 6.7993H24.569C24.9047 6.79964 25.2022 6.93159 25.4228 7.1482C25.6422 7.36615 25.776 7.65986 25.7764 7.99103V20.009C25.776 20.3402 25.6422 20.6339 25.4228 20.8515C25.2022 21.0685 24.9047 21.2005 24.569 21.2007H14.536C14.3848 21.2004 14.2617 21.0789 14.2614 20.9295V19.032H12.9453V20.9295C12.9458 21.7971 13.657 22.4994 14.536 22.5H24.569C25.9629 22.4997 27.0919 21.385 27.0924 20.009V7.99103C27.0919 6.61496 25.9629 5.50033 24.569 5.5Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2614 11.8125H12.9453V16.1915H14.2614V11.8125Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2455 17.6087C15.2455 17.2252 14.9306 16.9141 14.5425 16.9141H12.7772C12.3891 16.9141 12.0742 17.2252 12.0742 17.6087C12.0742 17.9922 12.3891 18.3031 12.7772 18.3031H14.5425C14.9306 18.3031 15.2455 17.9922 15.2455 17.6087Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.309 10.0312H17.3867V11.0057H23.309V10.0312Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.309 13.6094H17.3867V14.5838H23.309V13.6094Z",
    fill: "#5078C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0059 17.1797H17.3867V18.1541H21.0059V17.1797Z",
    fill: "#5078C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35722_277391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white",
    transform: "translate(12.082 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.84e558f49f1b90e31790e1cfe9515c6a.svg";
export { ForwardRef as ReactComponent };